<template>
  <base-section
    id="calcul"
  >
    <base-section-heading
      title="Calcul interactif"
      style="margin-bottom: 0!important;"
    >
    </base-section-heading>
    <v-container>
      <v-radio-group v-model="type" row>
        <v-radio cols="12" label="Piscine Ronde" value="Ronde"></v-radio>
        <v-radio label="Piscine Ovale" value="Ovale"></v-radio>
        <v-radio label="Piscine Carré/Rectangle" value="Rectangle"></v-radio>
        <v-radio label="Volume Direct" value="Direct"></v-radio>
      </v-radio-group>
      <v-row>
        <v-col v-if="canDisplayLongeur" cols="12" md="4" sm="4">
          <v-text-field
            v-model="longeur"
            label="Longeur (en Mètres)"
            outlined
            shaped
          ></v-text-field>
        </v-col>
        <v-col v-if="canDisplayLargeur" cols="12" md="4" sm="4">
          <v-text-field
            v-model="largeur"
            label="Largeur (en Mètres)"
            outlined
            shaped
          ></v-text-field>
        </v-col>
        <v-col v-if="canDisplayProfondeur" cols="12" md="4" sm="4">
          <v-text-field
            v-model="profondeur"
            label="Profondeur (en Mètres)"
            outlined
            shaped
          ></v-text-field>
        </v-col>
        <v-col v-if="canDisplayDiametre" cols="12" md="4" sm="4">
          <v-text-field
            v-model="diametre"
            label="Diamètre (en Mètres)"
            outlined
            shaped
          ></v-text-field>
        </v-col>
        <v-col v-if="canDisplayVolume" cols="12" md="4" sm="4">
          <v-text-field
            v-model="volume"
            label="Volume (en Mètres cube)"
            outlined
            shaped
          ></v-text-field>
        </v-col>

      </v-row>
      <base-section-heading
        title="Résultats"
        style="margin-bottom: 0!important;"
      >
      </base-section-heading>
      <v-row  v-if="canDisplayProfondeur">
        <v-col cols="6">
          <v-subheader>Volume de votre piscine (m3)</v-subheader>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="getVolume"
            filled
            disabled
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-subheader>Dose de Crystalline H20 par semaine (gr)</v-subheader>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="getDoseH2O"
            value="10.00"
            filled
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-subheader>Durée de votre contenant (en semaine)</v-subheader>
        </v-col>
        <v-col cols="3" sm="3">
          <v-select
            v-model="contenant"
            :items="gValues"
            filled
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-text-field
            filled
            v-model="getDureeSemaine"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFaq',
    computed: {
      canDisplayDiametre(){
        return this.type === "Ronde";
      },
      canDisplayLargeur(){
        return this.type === "Ovale" || this.type === "Rectangle";
      },
      canDisplayLongeur(){
        return this.type === "Ovale" || this.type === "Rectangle";
      },
      canDisplayProfondeur(){
        return !(this.type === "Direct") && (this.type === "Ovale" || this.type === "Rectangle" || this.type === "Ronde");
      },
      canDisplayVolume(){
        return (this.type === "Direct");
      },

      getVolume(){
        if(this.canDisplayDiametre || this.canDisplayLargeur || this.canDisplayLongeur || this.canDisplayVolume || this.canDisplayLargeur) {

          let result = 0;
          let profondeurError = false;
          let diametreError = false;
          let volumeError = false;
          let longeurError = false;
          let largeurError = false;


          if (this.checkError(this.profondeur)){
            profondeurError = true;
            this.profondeur = null;
          }


          if (this.checkError(this.diametre)){
            diametreError = true;
            this.diametre = null;
          }

          if (this.checkError(this.volume)){
            volumeError = true;
            this.volume = null;
          }


          if (this.checkError(this.longeur)){
            longeurError = true;
            this.longeur = null;
          }

          if (this.checkError(this.largeur)){
            largeurError = true;
            this.largeur = null;
          }


          switch(this.type) {
            case "Ronde":
              if (profondeurError || diametreError) return 0;
              result = this.profondeur * this.diametre * this.diametre * 0.78;
            break;
            case "Ovale":
              if (profondeurError || longeurError || largeurError) return 0;
              result = this.longeur * this.profondeur * this.largeur * 0.89;
              break;
            case "Rectangle":
              if (profondeurError || longeurError || largeurError) return 0;
              result = this.longeur * this.profondeur * this.largeur;
              break;
            case "Direct":
              if (volumeError ) return 0;
              result = this.volume
              break;
          }

          return Math.ceil(result);

        }

        return 0;

      },
    getDoseH2O() {
      if(this.canDisplayDiametre || this.canDisplayLargeur || this.canDisplayLongeur || this.canDisplayVolume)
        return Math.ceil(this.getVolume / 10 * 4);
      else
        return 0;
    },

    getDureeSemaine() {
      let pot = 0;

      switch (this.contenant) {
        case "Pot de 300 grammes":
          pot = 300
          break

        case "Pot de 700 grammes":
          pot = 700;
          break

        case "Pot d'1.3 Kg":
          pot = 1300;
          break
      }

      if(this.getDoseH2O !== 0 && (this.canDisplayDiametre || this.canDisplayLargeur || this.canDisplayLongeur || this.canDisplayVolume))
        return Math.ceil(pot / this.getDoseH2O)
      else
        return 0;
    }
    },
    methods: {
      checkError(val){
        return !parseInt(val) ||  parseInt(val) < 0
      },

      selected(what){
        this.rect = what === 'rect';
        this.ovale = what === 'ovale';
        this.ronde = what === 'ronde';
        this.direct = what === 'direct';
      }
    },
    data(){
      return {
        dose : null,
        volume : null,
        diametre : null,
        profondeur : null,
        longeur : null,
        largeur : null,
        ronde : false,
        rect : false,
        ovale : false,
        direct : false,
        contenant : "Pot de 300 grammes",
        gValues : [
          "Pot de 300 grammes",
          "Pot de 700 grammes",
          "Pot d'1.3 Kg",
        ],
        res1 : null,
        res2 : null,
        res3 : null,
        type : "Ronde",
      }
    }
  }
</script>
